export class MongoAtlasSourceAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "secretArn",
            "baseName": "secretArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MongoAtlasSourceAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
